export default __webpack_public_path__ + "static/EnergyLabelAndPrice2_x2-28ddfe7b6ebaa4631e7784adaa2d15ca.png";